import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useParams } from "react-router-dom";
import { addRating, fetchProductById } from "../../features/product/productThunks";
import StarRatings from "react-star-ratings";
import loadingLottie from "../../assets/lotties/loading.json";
import "./productDetails.css";
import Lottie from "lottie-react";
import ReviewSection from "../../components/reviewSection/reviewSection";
import { Helmet } from "react-helmet";

export default function ProductDetails() {

  const location = useLocation();
  const canonicalUrl = `https://shop-co-roan.vercel.app${location.pathname}`;

  const [activeTab, setActiveTab] = useState("details");
  const { id } = useParams();
  const dispatch = useDispatch();


  useEffect(() => {
    console.log("Active Tab:", activeTab);
  }, [activeTab]);

  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [selectedSize, setSelectedSize] = useState(null);

  const { currentItem, loading, reviews } = useSelector((state) => state.product);

  useEffect(() => {
    dispatch(fetchProductById(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (currentItem?.colors?.length > 0) {
      setSelectedColor(currentItem.colors[0]);
    }
  }, [currentItem]);

  useEffect(() => {
    if (selectedColor && currentItem?.imagesByColor?.length > 0) {
      const colorGroup = currentItem.imagesByColor.find(group => group.color === selectedColor);
      if (colorGroup?.images?.length > 0) {
        setSelectedImage(colorGroup.images[0]);
      }
    }
  }, [selectedColor, currentItem]);

  if (loading || !currentItem) {
    return (
      <div className="product-lottie-wrapper">
        <Lottie
          animationData={loadingLottie}
          loop
          autoplay
          className="product-lottie"
        />
      </div>
    );
  }

  const colorImages =
    currentItem.imagesByColor.find(group => group.color === selectedColor)?.images || [];

  const increaseQuantity = () => {
    setQuantity(prev => prev + 1);
  };

  const decreaseQuantity = () => {
    setQuantity(prev => (prev > 1 ? prev - 1 : 1));
  };

  return (
    <>
      <Helmet>
        <title>SHOP.CO | Product Details</title>
        <meta
          name="description"
          content="Discover detailed information about our premium products at SHOP.CO. High quality, best prices, and fast delivery."
        />

        <link rel="canonical" href={canonicalUrl} />
        
      </Helmet>
      <div className="product-details-page">
        <div className="product-container">

          <div className="product-all-images">
            <div className="product-images">
              {colorImages.map((img, index) => (
                <img
                  key={index}
                  src={`https://shop-co-backend-stk3.onrender.com/upload/${img}`}
                  alt="thumbnail"
                  className={`thumbnail ${selectedImage === img ? "active" : ""}`}
                  onClick={() => setSelectedImage(img)}
                />
              ))}
            </div>

            <div className="product-main-image">
              <img src={`https://shop-co-backend-stk3.onrender.com/upload/${selectedImage}`} alt="main" />
            </div>
          </div>

          <div className="product-info">
            <h1>{currentItem.name}</h1>

            <div className="rating">
              <StarRatings
                rating={currentItem.averageRating}
                starRatedColor="gold"
                numberOfStars={5}
                starDimension="20px"
                starSpacing="2px"
              />
              <span>{currentItem.averageRating.toFixed(1)}/5</span>
            </div>

            <div className="price-box">
              <span className="new-price">${currentItem.priceAfterDiscount}</span>
              <span className="old-price">${currentItem.price}</span>
              <span className="discount">-{currentItem.discount}%</span>
            </div>

            <p className="description">{currentItem.description}</p>

            <div className="color-section">
              <h4>Select Colors:</h4>
              <div className="color-options">
                {currentItem.colors.map((color, i) => (
                  <div
                    key={i}
                    className="color-circle"
                    style={{
                      backgroundColor: color,
                      borderColor: selectedColor === color ? "black" : "#ccc",
                      borderWidth: selectedColor === color ? "2px" : "1px"
                    }}
                    onClick={() => setSelectedColor(color)}
                  ></div>
                ))}
              </div>
            </div>

            <div className="size-section">
              <h4>Choose Size:</h4>
              <div className="sizes">
                {currentItem.sizes.map((size, i) => (
                  <button
                    key={i}
                    className={`size-btn ${selectedSize === size ? "selected" : ""}`}
                    onClick={() => setSelectedSize(size)}
                  >
                    {size}
                  </button>
                ))}
              </div>
            </div>
            <div className="quantity-cart">
              <div className="quantity-control">
                <button onClick={decreaseQuantity}>-</button>
                <span>{quantity}</span>
                <button onClick={increaseQuantity}>+</button>
              </div>
              <Link to="/coming-soon">
                <button className="add-to-cart">Add to Cart</button>
              </Link>
            </div>
          </div>
        </div>
        <div className="product-tabs">
          <button
            className={activeTab === "details" ? "tab active" : "tab"}
            onClick={() => setActiveTab("details")}
          >
            Product Details
          </button>
          <button
            className={activeTab === "reviews" ? "tab active" : "tab"}
            onClick={() => setActiveTab("reviews")}
          >
            Rating & Reviews
          </button>
        </div>

        <div className="tab-content">
          {activeTab === "details" && (
            <div className="product-details-section">
              <table className="details-table">
                <tbody>
                  <tr><td>Brand</td><td>{currentItem.brand}</td></tr>
                  <tr><td>Category</td><td>{currentItem.category}</td></tr>
                  <tr><td>Type</td><td>{currentItem.typeOfProduct}</td></tr>
                  <tr><td>Material</td><td>{currentItem.material}</td></tr>
                  <tr><td>Dimensions</td><td>{currentItem.dimensionsWidth} x {currentItem.dimensionsHeight}</td></tr>
                  <tr><td>Release Date</td><td>{new Date(currentItem.releaseDate).toLocaleDateString()}</td></tr>
                  <tr><td>Sales Count</td><td>{currentItem.salesCount}</td></tr>
                  <tr><td>Discount</td><td>{currentItem.discount}%</td></tr>
                  <tr><td>Price Before</td><td>${currentItem.price}</td></tr>
                  <tr><td>Price After</td><td>${currentItem.priceAfterDiscount}</td></tr>
                </tbody>
              </table>
            </div>
          )}

          {activeTab === "reviews" && (
            <ReviewSection productId={id} />
          )}
        </div>

      </div>
    </>
  );
}
